<template>
	<CardGrafico :subtitle="updatedAt">
		<template #grafico>
			<Loading v-if="series.length === 0" />
			<div
				v-else
				class="container__grafico__dispersao"
			>
				<slot name="action-buttons" />
				<Chart
					id="dispersao__parcelas"
					ref="ref__chart"
					:update-args="[chartOptions, true]"
					:options="chartOptions"
				/>
			</div>
		</template>
	</CardGrafico>
</template>

<script>
import { Chart } from 'highcharts-vue'
import CardGrafico from '../CardGrafico/CardGrafico'
import Loading from '../../components/Loading/Loading'

// import _ from "lodash";

import { stringToExportCSV } from '../../utils/csvHellpers'

export default {
	components: { CardGrafico, Loading, Chart },
	props: {
		/**
		 * Dados que devem ir para o grafico
		 */
		xTitulo: { type: String, default: '' },
		yTitulo: { type: String, default: '' },
		titulo: { type: String, default: '' },
		infoGrafico: { type: Object },
		series: { type: Array, required: true },
		updatedAt: { type: String, required: false, default: '' },
	},
	data() {
		return {
			dropdownTipoGrafico: 'vtcc',
			dropdownDownload: '',
			parcelasTemporarias: [],
			chartScopes: [
				{ label: 'Altura Dominante', value: 'alturaDominante' },
				{ label: 'VTCC', value: 'vtcc' },
				{ label: 'VTSC', value: 'vtsc' },
				{ label: 'Área Basal', value: 'areaBasal' },
				{ label: 'Diâmetro Médio', value: 'diametroMedio' },
			],
		}
	},
	computed: {
		/**
		 * Options para configuracao do grafico
		 */
		chartOptions() {
			return {
				chart: {
					type: 'column',
					zoomType: 'xy',
					// redraw: true
				},
				lang: {
					resetZoom: 'Resetar zoom',
				},
				title: {
					text: this.titulo,
					style: {
						fontSize: '100%',
					},
				},
				subtitle: {
					text: '',
				},
				xAxis: [
					{},
					{
						tickInterval: 1,
						title: {
							text: this.xTitulo,
							style: {
								fontSize: '100%',
							},
						},
					},
				],

				yAxis: [
					{
						title: {
							text: null,
						},
					},

					{
						title: {
							text: this.yTitulo,
							style: {
								fontSize: '100%',
							},
						},
					},
				],
				legend: {
					enabled: false,
				},
				tooltip: {
					positioner: function () {
						return { x: 40, y: 25 }
					},
					headerFormat: '<b>{point.codigoParcela}</b><br>',
					pointFormat:
						'Resíduos' +
						': {point.x:.3f} ' +
						this.infoGrafico.unidade.replace('(', '').replace(')', '') +
						'<br>' +
						'Quantidade ' +
						': {point.y} ',
				},
				series: [
					{
						type: 'histogram',
						name: 'Quantidade',
						turboThreshold: Number.MAX_SAFE_INTEGER,
						xAxis: 1,
						yAxis: 1,
						color: `rgb(149, 187, 73)`,
						enable: true,
						baseSeries: 's1',
						zIndex: -1,
						animation: false,
					},
					{
						name: 'Data',
						turboThreshold: Number.MAX_SAFE_INTEGER,
						type: 'scatter',
						data: this.dadosDispersao,
						visible: false,
						id: 's1',
						animation: false,
						marker: {
							radius: 1.5,
						},
					},
				],
			}
		},

		/**
		 * Prepara os dados para serem plotadas no grafico de dispersao
		 */
		dadosDispersao() {
			return this.series
		},

		/**
		 * Configuracao do grafico de acordo com o tipo exibido
		 */
		configuracaoDoGrafico() {
			if (this.dropdownTipoGrafico === 'vtcc') {
				return {
					tipoDoGrafico: 'Volume Total com Casca (m³/ha)',
					titulo: 'Volume Total com Casca por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'vtsc') {
				return {
					tipoDoGrafico: 'Volume Total sem Casca (m³/ha)',
					titulo: 'Volume Total sem Casca por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'alturaDominante') {
				return {
					tipoDoGrafico: 'Altura Dominante',
					titulo: 'Altura Dominante por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else if (this.dropdownTipoGrafico === 'areaBasal') {
				return {
					tipoDoGrafico: 'Área Basal',
					titulo: 'Área Basal por faixa de idade',
					posicaoDataLabel: -35,
				}
			} else {
				return {
					tipoDoGrafico: 'Diâmetro Médio',
					titulo: 'Diâmetro Médio por faixa de idade',
					posicaoDataLabel: -55,
				}
			}
		},
	},
	watch: {
		/**
		 * Tipo do grafico que deve ser mostrado
		 * Área Plantada, Volume ou IMA
		 */
		dropdownTipoGrafico() {
			this.changeHighchartsOptions()
			this.$emit('tipoGrafico', this.dropdownTipoGrafico)
		},
		/**
		 * Seleciona a opcao de download escolhida
		 */
		dropdownDownload(type) {
			if (type) {
				const filename = `${new Date().getTime()}`
				if (type === 'text/csv') {
					const csv = this.$refs.ref__chart.chart.getCSV()
					stringToExportCSV(filename, csv)
				} else {
					this.$refs.ref__chart.chart.exportChart({ filename, type })
				}
				this.dropdownDownload = ''
			}
		},
	},
	mounted() {
		const rgbDefaultColor = getComputedStyle(document.body).getPropertyValue('--color-default')
		this.chartOptions.series[0].color = `rgb(${rgbDefaultColor})`
	},

	methods: {},
}
</script>

<style scoped>
@media screen and (max-width: 1370px) {
	.container__grafico__dispersao {
		display: block;
		flex-direction: column;
		font-size: 10%;
	}
}

/* @import url("../../css/tooltipSimplesHighcharts.css"); */
.container__grafico__dispersao {
	display: block;
	flex-direction: column;
	height: 100%;
}

.highcharts-container {
	margin: 0 !important;
	height: 100% !important;
}

#dispersao__parcelas {
	height: 100%;
}
</style>
